// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".compilation-preview[data-v-d57d49b2]{position:relative;z-index:1;width:100%;height:36vh;overflow:hidden}.compilation-preview .i-bg[data-v-d57d49b2]{width:100%}.compilation-preview .i-bg img[data-v-d57d49b2]{max-width:100%;-o-object-fit:cover;object-fit:cover;min-height:100%;min-width:100%;height:auto;width:auto;vertical-align:top}", ""]);
// Exports
module.exports = exports;
